import { API } from "../auth/authApi";

API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");

  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }

  return req;
});

export const getRatingsApi = (page, limit) => {
  return API.get(`/user/rating/all?page=${page}&limit=${limit}`);
};
